import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const TransferBalanceContent = Box.withConfig({
  width: {
    base: 343,
    md: 528,
  },
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'center',
  padding: '$4',
  backgroundColor: primitive.$white,
  borderRadius: 10,
  marginY: '$4',
});

export const TextContainer = Box.withConfig({
  flexDirection: 'row',
  mb: '$6',
});

export const BalanceText = withTypography({ fontSize: 'md' });
